export default "__VITE_ASSET__BSBfdhQG__"